import { Action } from '@ngrx/store';
import { Customer } from './../../../core/models/customer.model';
import { Company } from './../../../core/models/company.model';
import { Jobsite } from './../../../core/models/jobsite.model';
import { PaymentDocument } from './../../../components/bulk-payment/models/payment-document.model';
import { Update } from '@ngrx/entity';
import { PaymentMethod } from './../../models/payment-method';
import { PaymentNetwork } from './../../models/payment-network';
import { PayerBrokerResponse } from './../../models/payer-broker-response';
import { PaymentHeader } from './../../models/payment-header';
import { IExternalAppData } from '../../../core/models/externalAppData.model';

export enum PaymentProcessActionTypes {
    START_PAYMENT_PROCESS = '[PAYMENTS] Start Payment Process',
    SELECT_CUSTOMER = '[PAYMENTS] Select Customer',
    SELECT_COMPANY = '[PAYMENTS] Select Company',
    SELECT_JOBSITE = '[PAYMENT Select Jobsite',
    SELECT_PAYMENT_METHOD = '[PAYMENTS] Select Payment Method',
    SELECT_NETWORKING = '[PAYMENTS] Select Networking',
    SELECT_NETWORKING_DETAIL = '[PAYMENTS] Select Networking Detail',
    SET_PAYMENT_HEADER = '[PAYMENTS] Set Payment Header',
    SET_PAYMENT_EXTERNAL_DATA = '[PAYMENTS] Set Payment External Data',
    ADD_PAYMENT_DOCUMENTS = '[PAYMENTS] Add Payment Documents',
    UPDATE_PAYMENT_DOCUMENTS = '[PAYMENTS] Update Payment Documents',
    REMOVE_PAYMENT_DOCUMENTS = '[PAYMENTS] Remove Payment Documents',
    UPDATE_PAYMENT_DOCUMENT = '[PAYMENTS] Update Payment Document',
    REMOVE_PAYMENT_DOCUMENT = '[PAYMENTS] Remove Payment Document',
    SET_DOCUMENTS_AMOUNT_DUE = '[PAYMENTS] Set Documents Amount Due',
    CREATE_REFERENCE_PAYMENT = '[PAYMENTS] Create Reference Payment',
    CREATE_REFERENCE_PAYMENT_SUCCESS = '[PAYMENTS] Create Reference Payment Success',
    CREATE_REFERENCE_PAYMENT_FAILURE = '[PAYMENTS] Create Reference Payment Failure',
    GET_PAYER_INFORMATION = '[PAYMENTS] Get Payer Information',
    GET_PAYER_INFORMATION_SUCCESS = '[PAYMENTS] Get Payer Information Success',
    INIT_PAYMENT_ENGINE_SERVICE = '[PAYMENTS] Init Payment Engine Service',
    CALL_TO_NETWORKING = '[PAYMENTS] Call To Networking',
    UPDATE_SALES_ORDER_NUMBER = '[PAYMENTS] Update Sales Order Number',

}

export namespace PaymentProcessActions {

    export class StartPaymentProcess implements Action {
        readonly type = PaymentProcessActionTypes.START_PAYMENT_PROCESS;
    }

    export class SelectCustomer implements Action {
        readonly type = PaymentProcessActionTypes.SELECT_CUSTOMER;

        constructor(public payload: string) {}
    }

    export class SelectCompany implements Action {
        readonly type = PaymentProcessActionTypes.SELECT_COMPANY;

        constructor(public payload: string) {}
    }

    export class SelectJobsite implements Action {
        readonly type = PaymentProcessActionTypes.SELECT_JOBSITE;

        constructor(public payload: string) {}
    }

    export class SelectPaymentMethod implements Action {
        readonly type = PaymentProcessActionTypes.SELECT_PAYMENT_METHOD;

        constructor(public payload: string) {}
    }

    export class SelectNetworking implements Action {
        readonly type = PaymentProcessActionTypes.SELECT_NETWORKING;

        constructor(public payload: string) {}
    }

    export class SelectNetworkingDetail implements Action {
        readonly type = PaymentProcessActionTypes.SELECT_NETWORKING_DETAIL;

        constructor(public payload: string) {}
    }

    export class SetPaymentHeader implements Action {
        readonly type = PaymentProcessActionTypes.SET_PAYMENT_HEADER;

        constructor(public payload: PaymentHeader) {}
    }

    export class SetPaymentExternalData implements Action {
        readonly type = PaymentProcessActionTypes.SET_PAYMENT_EXTERNAL_DATA;

        constructor(public payload: IExternalAppData) {}
    }
    export class AddPaymentDocumets implements Action {
        readonly type = PaymentProcessActionTypes.ADD_PAYMENT_DOCUMENTS;

        constructor(public payload: PaymentDocument[]) {}
    }

    export class UpdatePaymentDocuments implements Action {
        readonly type = PaymentProcessActionTypes.UPDATE_PAYMENT_DOCUMENTS;

        constructor(public payload: Update<PaymentDocument>[]) {}
    }

    export class RemovePaymentDocuments implements Action {
        readonly type = PaymentProcessActionTypes.REMOVE_PAYMENT_DOCUMENTS;
    }

    export class UpdatePaymentDocument implements Action {
        readonly type = PaymentProcessActionTypes.UPDATE_PAYMENT_DOCUMENT;

        constructor(public payload: Update<PaymentDocument>) {}
    }

    export class RemovePaymentDocument implements Action {
        readonly type = PaymentProcessActionTypes.REMOVE_PAYMENT_DOCUMENT;

        constructor(public payload: string) {}
    }

    export class SetDocumentsAmountDue implements Action {
        readonly type = PaymentProcessActionTypes.SET_DOCUMENTS_AMOUNT_DUE;
    }

    export class CreateReferencePayment implements Action {
        readonly type = PaymentProcessActionTypes.CREATE_REFERENCE_PAYMENT;
    }

    export class CreateReferencePaymentSuccess implements Action {
        readonly type = PaymentProcessActionTypes.CREATE_REFERENCE_PAYMENT_SUCCESS;

        constructor(public payload: string) {}
    }

    export class CreateReferencePaymentFailure implements Action {
        readonly type = PaymentProcessActionTypes.CREATE_REFERENCE_PAYMENT_FAILURE;
    }

    export class GetPayerInfomation implements Action {
        readonly type = PaymentProcessActionTypes.GET_PAYER_INFORMATION;
    }

    export class GetPayerInfomationSuccess implements Action {
        readonly type = PaymentProcessActionTypes.GET_PAYER_INFORMATION_SUCCESS;

        constructor(public payload: PayerBrokerResponse) {}
    }

    export class InitPaymentEngineService implements Action {
        readonly type = PaymentProcessActionTypes.INIT_PAYMENT_ENGINE_SERVICE;
    }

    export class CallToNetworking implements Action {
        readonly type = PaymentProcessActionTypes.CALL_TO_NETWORKING;
    }

    export class UpdateSalesOrderNumber implements Action {
        readonly type = PaymentProcessActionTypes.UPDATE_SALES_ORDER_NUMBER;

        constructor(public payload: string) {}
    }
}

export type PaymentProcessActions =
    | PaymentProcessActions.StartPaymentProcess
    | PaymentProcessActions.SelectCustomer
    | PaymentProcessActions.SelectCompany
    | PaymentProcessActions.SelectJobsite
    | PaymentProcessActions.SelectPaymentMethod
    | PaymentProcessActions.SelectNetworking
    | PaymentProcessActions.SelectNetworkingDetail
    | PaymentProcessActions.SetPaymentHeader
    | PaymentProcessActions.SetPaymentExternalData
    | PaymentProcessActions.AddPaymentDocumets
    | PaymentProcessActions.UpdatePaymentDocuments
    | PaymentProcessActions.RemovePaymentDocuments
    | PaymentProcessActions.UpdatePaymentDocument
    | PaymentProcessActions.RemovePaymentDocument
    | PaymentProcessActions.SetDocumentsAmountDue
    | PaymentProcessActions.CreateReferencePayment
    | PaymentProcessActions.CreateReferencePaymentSuccess
    | PaymentProcessActions.CreateReferencePaymentFailure
    | PaymentProcessActions.GetPayerInfomation
    | PaymentProcessActions.GetPayerInfomationSuccess
    | PaymentProcessActions.InitPaymentEngineService
    | PaymentProcessActions.CallToNetworking
    | PaymentProcessActions.UpdateSalesOrderNumber;
